import React from 'react';
import { ICoreContext } from '@msdyn365-commerce/core';
import { formatDate, formatNumber } from '../../../utilities';
import { ILxsCreateOrderResources } from '../lxs-create-order.props.autogenerated';
import { IPostCreateOrderResponseData } from '../../../actions/post-create-order.action';
import { NO_DATA_FALLBACK } from '../../../configuration';

export default function orderItems({
    context,
    itemsData,
    resources,
    productsHaveEndcustomers
}: {
    context: ICoreContext;
    itemsData: IPostCreateOrderResponseData;
    resources: ILxsCreateOrderResources;
    productsHaveEndcustomers: boolean;
}) {
    return (
        <>
            <h3 className='ms-order-details__section-heading'>{resources.createOrderItemsHeading}</h3>
            <div className='table-responsive'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>{resources.createOrderItemsTablePosition}</th>
                            <th>{resources.createOrderItemsTableProductName}</th>
                            <th>{resources.createOrderItemsTableProductNumber}</th>
                            <th>{resources.createOrderSelectedProductsTableRequestedDeliveryDate}</th>
                            <th>{resources.createOrderSelectedProductsReqQuantity}</th>
                            {productsHaveEndcustomers && <th>{resources.createOrderSelectedProductsTableEndCustomer}</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {itemsData?.Order.OrderLines?.map((item, index) => (
                            <tr key={index}>
                                <td>{(index + 1) * 10}</td>
                                <td>{item.ProductName}</td>
                                <td>{item.ProductNumber}</td>
                                <td>{!!item.RequestedDate ? formatDate(context, new Date(item.RequestedDate)) : NO_DATA_FALLBACK}</td>
                                <td>{`${formatNumber(context, Number(item.RequestedQty))} ${item.RequestedUnit}`}</td>
                                {productsHaveEndcustomers && <td>{item.EndCustomer}</td>}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}
